import moment from "moment";
import { create } from "xmlbuilder2";

export const parseAndFormatDate = (timestamp: string) => {
  const readableDate = moment(timestamp).format("MMMM Do YYYY, h:mm:ss A");
  return readableDate;
};

export const parseRolesFromXML = (xmlString: string) => {
  try {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlString, "text/xml");

    const stringElements = xmlDoc.getElementsByTagName("string");

    const result = Array.from(stringElements).map(
      (node) => node.textContent || ""
    );

    return result;
  } catch (error) {
    console.error("Error parsing XML:", error);
    return [];
  }
};

export const createRoleInXml = (roles: string[]) => {
  const xmlObj = create({ version: "1.0", encoding: "utf-16" }).ele(
    "ArrayOfString",
    {
      "xmlns:xsi": "http://www.w3.org/2001/XMLSchema-instance",
      "xmlns:xsd": "http://www.w3.org/2001/XMLSchema",
    }
  );

  roles.forEach((role) => {
    xmlObj.ele("string").txt(role);
  });

  return xmlObj.end({ prettyPrint: true });
};
